import { c as _c } from "react/compiler-runtime";
import { MemberName } from "@components/table/members/remove-xg-seat/remove-xg-seat-list";
import { Text } from "@flat-ui";

/**
 * Last step of taking a Sphere XG seat away from a member who is not an admin in the workspace, once their
 * other roles that need a seat were resolved, which only asks the user to confirm.
 */
export function RemoveXgSeatConfirmStep(t0) {
  const $ = _c(3);
  const {
    member
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <strong>Remove seat</strong>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== member) {
    t2 = <Text variant="bodyM">Select {t1} to take the Sphere XG seat away from{" "}<MemberName member={member} />.</Text>;
    $[1] = member;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}